import { createSlice } from "@reduxjs/toolkit";

export const initialVehicleLocalState = {
  vehicle_type: "",
  name: "",
  seats: null,
  capacity: null,
  efficiency: null,
  cost_per_mile: null,
  fuel_type: "",
  reg_number: "",
  mot_due: "",
  service_due: "",
};

export const initialVehicleTypeLocalState = {
  vehicle_type: "",
  description: "",
  seats: null,
  capacity: null,
  efficiency: null,
  cost_per_mile: null,
  fuel_type: '',
};

export const initialServiceLocalState = {
  vehicle_id: null,
  date: null,
  title: "",
  cost: null,
  is_paid: false,
};

export const vehicleSlice = createSlice({
  name: "vehicle",
  initialState: {
    vehicles: [],
    vehiclePaginationData: {},
    workerVehicles: [],
    vehicleTypes: [],
    vehicleServiceHistory: [],
    vehServiceHistPaginationData:{},
    singleVehicleType: {},
    singleVehicle: {},
    isAddVehicleResponse: false,
    isAddVehicleTypeResponse: false,
    isDeleteVehicleTypeResponse:false,
    isUpdateVehicleResponse: false,
    isAddWorkerVehicleResponse: false,
    isAddVehicleServiceHistory: false,
    isAddFuelDetails: false,
    fuelDetails: {},
    isVehicleError: false,
    newVehicleLocal: initialVehicleLocalState,
    newVehicleTypeLocal: initialVehicleTypeLocalState,
    isVehicleServicePaid: false,
    isVehicleServiceDeleted: false,
  },

  reducers: {
    getAllVehicles: (state) => {},
    getAllVehiclesWithPagination: (state, { payload }) => {},
    setAllVehicles: (state, { payload }) => {
      state.vehicles = payload?.list;
      state.vehiclePaginationData = payload?.pagination;
    },

    addVehicleTypeAction: (state, { payload }) => {},
    setAddVehicleTypeResponse: (state, { payload }) => {
      state.isAddVehicleTypeResponse = payload;
    },

    getVehicleTypes: (state) => {},
    setVehicleTypes: (state, { payload }) => {
      state.vehicleTypes = payload;
    },

    updateVehicleTypes: (state, { payload }) => {},
    setUpdateVehicleTypeResponse: (state, { payload }) => {
      state.isAddVehicleTypeResponse = payload;
    },

    deleteVehicleType: (state, { payload }) => {},
    deleteVehicleTypeSuccess: (state, { payload }) => {
      state.isDeleteVehicleTypeResponse = payload;
    },

    getSingleVehicleTypeDetails: (state, { payload }) => {},
    setSingleVehicleTypeDetails: (state, { payload }) => {
      state.singleVehicleType = payload;
    },

    addVehicleAction: (state, { payload }) => {},
    setAddVehicleResponse: (state, { payload }) => {
      state.isAddVehicleResponse = payload;
    },

    updateVehiclesAction: (state, { payload }) => {},
    setUpdateVehicleResponse: (state, { payload }) => {
      state.isUpdateVehicleResponse = payload;
    },

    deleteVehicleAction: (state, { payload }) => {},
    deleteVehicleSuccess: (state, { payload }) => {
      state.isAddVehicleResponse = payload;
    },

    updateVehicleError: (state, { payload }) => {
      state.isVehicleError = payload;
    },

    getVehicleById: (state, { payload }) => {},
    setVehicleById: (state, { payload }) => {
      state.singleVehicle = payload;
    },
    setNewVehicleLocal: (state, action) => {
      state.newVehicleLocal = {
        ...state.newVehicleLocal,
        ...action.payload,
      };
    },

    resetNewVehicleLocal: (state) => {
      state.newVehicleLocal = initialVehicleLocalState;
    },

    setNewVehicleTypeLocal: (state, action) => {
      state.newVehicleTypeLocal = {
        ...state.newVehicleTypeLocal,
        ...action.payload,
      };
    },

    resetNewVehicleTypeLocal: (state) => {
      state.newVehicleTypeLocal = initialVehicleTypeLocalState;
    },

    getAllWorkerVehicles: (state) => {},
    setAllWorkerVehicles: (state, { payload }) => {
      state.workerVehicles = payload;
    },

    addWorkerVehiclesAction: (state, { payload }) => {},
    setWorkerVehiclesAction(state, { payload }) {
      state.isAddWorkerVehicleResponse = payload;
    },

    addVehicleServiceHistory: (state, { payload }) => {},
    setAddVehicleServiceHistory: (state, { payload }) => {
      state.isAddVehicleServiceHistory = payload;
    },

    getVehicleServiceHistory: (state, { payload }) => {},
    setVehicleServiceHistory: (state, { payload }) => {
      state.vehicleServiceHistory = payload?.list;
      state.vehServiceHistPaginationData = payload?.pagination;
    },

    getFuelDetails: (state) => {},
    setFuelDetails: (state, { payload }) => {
      state.fuelDetails = payload;
    },

    addFuelDetails: (state, { payload }) => {},
    setAddFuelDetails: (state, { payload }) => {
      state.isAddFuelDetails = payload;
    },

    addVehicleServicePaid: (state, { payload }) => {},
    setVehicleServicePaid: (state, { payload }) => {
      state.isVehicleServicePaid = payload;
    },

    deleteVehicleService: (state, { payload }) => {},
    deleteVehicleServiceSuccess: (state, { payload }) => {
      state.isVehicleServiceDeleted = payload;
    },
  },
});

const {
  getAllVehicles,
  getAllVehiclesWithPagination,
  setAllVehicles,
  addVehicleTypeAction,
  setAddVehicleTypeResponse,
  getVehicleTypes,
  setVehicleTypes,
  addVehicleAction,
  setAddVehicleResponse,
  updateVehiclesAction,
  setUpdateVehicleResponse,
  updateVehicleError,
  getVehicleById,
  setVehicleById,
  setNewVehicleLocal,
  resetNewVehicleLocal,
  getAllWorkerVehicles,
  setAllWorkerVehicles,
  addWorkerVehiclesAction,
  setWorkerVehiclesAction,
  getSingleVehicleTypeDetails,
  setSingleVehicleTypeDetails,
  addVehicleServiceHistory,
  setAddVehicleServiceHistory,
  getVehicleServiceHistory,
  updateVehicleTypes,
  setUpdateVehicleTypeResponse,
  setVehicleServiceHistory,
  setNewVehicleTypeLocal,
  resetNewVehicleTypeLocal,
  getFuelDetails,
  setFuelDetails,
  addFuelDetails,
  setAddFuelDetails,
  addVehicleServicePaid,
  setVehicleServicePaid,
  deleteVehicleService,
  deleteVehicleServiceSuccess,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  deleteVehicleAction,
  deleteVehicleSuccess,
} = vehicleSlice.actions;

export {
  getAllVehicles,
  getAllVehiclesWithPagination,
  setAllVehicles,
  addVehicleTypeAction,
  setAddVehicleTypeResponse,
  getVehicleTypes,
  setVehicleTypes,
  addVehicleAction,
  setAddVehicleResponse,
  updateVehiclesAction,
  setUpdateVehicleResponse,
  updateVehicleError,
  getVehicleById,
  setVehicleById,
  setNewVehicleLocal,
  resetNewVehicleLocal,
  getAllWorkerVehicles,
  setAllWorkerVehicles,
  addWorkerVehiclesAction,
  setWorkerVehiclesAction,
  updateVehicleTypes,
  setUpdateVehicleTypeResponse,
  getSingleVehicleTypeDetails,
  setSingleVehicleTypeDetails,
  addVehicleServiceHistory,
  setAddVehicleServiceHistory,
  getVehicleServiceHistory,
  setVehicleServiceHistory,
  setNewVehicleTypeLocal,
  resetNewVehicleTypeLocal,
  getFuelDetails,
  setFuelDetails,
  addFuelDetails,
  setAddFuelDetails,
  addVehicleServicePaid,
  setVehicleServicePaid,
  deleteVehicleService,
  deleteVehicleServiceSuccess,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  deleteVehicleAction,
  deleteVehicleSuccess,
};
export default vehicleSlice.reducer;
